import SiteView from '../../components/SiteView'
import { Breadcrumbs, Grid, Link, Typography } from '@mui/material'
import { PADDING_BASE } from '../../assets/Styles'
import TopSideBar from '../../components/TopSideBar'
import PageContainer from '../../components/common/PageContainer'
import { useParams } from 'react-router-dom'


export default function SiteViewPage({ setBlockScreen, setSuccessMessage }: any) {
  const params = useParams<{ site_code?: string }>()
  const site_code = params.site_code ?? ''

  return (<>
    <TopSideBar currentSection='sites' disableProjectSelector />
    <PageContainer>

      <Grid paddingBottom={PADDING_BASE}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="darkgreen" href="/tickets/listing">
            Home
          </Link>
          <Link underline="hover" color="darkgreen" href="/sites/listing">
            Sitios
          </Link>
          <Typography color="darkgreen" fontWeight={"bold"}>
            Detalle
          </Typography>
        </Breadcrumbs>
      </Grid>

      <SiteView
        site_code={site_code}
        setBlockScreen={setBlockScreen}
        setSuccessMessage={setSuccessMessage}
      />
    </PageContainer>
  </>)
}
